module.exports = __webpack_public_path__ + "static/media/nova.eb091119.jpg";